import React from 'react'
import {Header, List} from 'semantic-ui-react'
import SyntaxHighlighter from 'react-syntax-highlighter'
import {docco} from 'react-syntax-highlighter/dist/esm/styles/hljs'
import {stripIndent} from 'common-tags'

const TemplateResponse = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Template Response</Header>
      <p>
        There may be cases where the response you return needs to include values received from the request
        or from calculated variables you produce in your activation script. Service Mocks response headers
        and bodies allow for inclusion of <a href='https://ejs.co/' target='_blank'>EJS</a> template syntax to achieve this. You have access to the
        entire request (req), response (res), and variable (vars) attributes via an object that is supplied
        during response preparation (see below).
      </p>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Navigate to the service/version/environment/resource you wish to work with.</List.Item>
        <List.Item>2. Click on the "Cog" icon and then the "Edit" icon for the response you want to script</List.Item>
        <List.Item>3. Click on "Return" tab and click either of the "Headers" or "Body" nav links beneath</List.Item>
        <List.Item>4. Enter the the <a href='https://ejs.co/' target='_blank'>EJS</a> template references to the Headers and/or Body.</List.Item>
        <List.Item>5. Click the "Update" button</List.Item>
      </List>
      <Header as='h3' dividing>EJS Data</Header>
      <div>
        <SyntaxHighlighter language="javascript" style={docco}>
          {
            stripIndent`
              {
                // request data
                req: {
                  verb: "<verb_used_to_issue_request_to_mock>"
                  path: "<path_provided_to_mock>",
                  headers: {
                    "<header_key>": "<header_value>"
                  },    
                  query: {
                    "<query_param_key>": "<query_param_value">
                  },   
                  params: {
                    "<query_param_key>": "<query_param_value">
                  },
                  body: <text|json|xml>,
                  xmlBodyAsJson: {}
                 }
                },
                // response data
                res: {        
                  status: <http_status_code>
                  active: <boolean_to_activate_response>,
                  headers: {
                    "<header_key>": "<header_value>"
                  },    
                  body: <text|json|xml>,
                  sleep: <integer_delay_in_ms_to_apply>,
                  vars: {
                    "var_one_key": "some_string_value",
                    "var_two_key": true,
                    "var_three_key": 123 
                  }
                }
              }
            `
          }
        </SyntaxHighlighter>
      </div>
      <Header as='h3' dividing>Template Headers</Header>
      <div>
        <SyntaxHighlighter language="javascript" style={docco}>
          {
            stripIndent
            `
             {
               "x-correlation-id": "<%=req.headers['x-correlation-id']'%>"
             }
            `
          }
        </SyntaxHighlighter>
      </div>
      <Header as='h3' dividing>Template Body</Header>
      <div>
        <SyntaxHighlighter language="javascript" style={docco}>
          {
            stripIndent
              `
             {
               "email": "<%=req.body.email%>".
               "balance": "<%=res.vars.balance%>
             }
            `
          }
        </SyntaxHighlighter>
      </div>
    </div>
  )
}

export {TemplateResponse}

export default TemplateResponse